import { Typography, Card } from 'antd'

const { Title } = Typography

const NotificationsPage = () => {
  return (
    <div>
      <Title level={2}>Notifiche</Title>
      <Card>
        <p>Gestione notifiche - In sviluppo</p>
      </Card>
    </div>
  )
}

export default NotificationsPage
